import { TFunction } from 'i18next';
import Input from '@lib/components/Input/Input';
import RadioButtonGroup, {
  RadioButtonWrapViews,
} from '@lib/components/RadioButtonGroup/RadioButtonGroup';
import RadioButtonAsChipColor from '@lib/components/RadioButtonAsChipColor/RadioButtonAsChipColor';
import {
  getFieldValidation,
  getOptionValidation,
} from '@lib/utils/validationUtils';
import { FieldItem } from '@lib/interfaces/form';
import FormTemplateCategoryFieldNames from '@lib/enums/fieldNames/formTemplateCategoryFieldNames';
import getColorOptions from '@lib/components/Chip/utils/colorEnum';

type IndustryFormFieldsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getCategoryFormFields({
  t,
}: IndustryFormFieldsArgs): FieldItem[] {
  return [
    {
      name: FormTemplateCategoryFieldNames.Name,
      label: t('category-name'),
      element: Input,
      validation: getFieldValidation({ t, required: true }),
      componentProps: {
        autoFocus: true,
      },
    },
    {
      name: FormTemplateCategoryFieldNames.Color,
      label: t('label-color'),
      element: RadioButtonGroup,
      validation: getOptionValidation({ t, required: true }),
      componentProps: {
        options: getColorOptions({ t }),
        RadioButtonComponent: RadioButtonAsChipColor,
        wrapView: RadioButtonWrapViews.colors,
      },
    },
  ];
}
